import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useInstitutionOnboardingIneligiblePath } from '@/features/institution/hooks/useInstitutionOnboardingIneligiblePath';
import { useProfileInstitutionDetailsAnswers } from '@/hooks/queries/use-profile-institution-details';

const InstitutionOnboardingEligibilityGuard = () => {
  const location = useLocation();
  const { data: institutionDetailsAnswers } = useProfileInstitutionDetailsAnswers();
  const ineligiblePath = useInstitutionOnboardingIneligiblePath('/institution/onboarding', institutionDetailsAnswers);

  if (ineligiblePath && location.pathname !== ineligiblePath) return <Navigate to={ineligiblePath} replace />;

  return <Outlet />;
};
InstitutionOnboardingEligibilityGuard.displayName = 'InstitutionOnboardingEligibilityGuard';

export default InstitutionOnboardingEligibilityGuard;
